import { ModalScreenPension } from '../../general/ModalScreen';
import { Button } from '../../general/Button';
import { HTMLProps } from 'react';
import { useTranslation } from 'react-i18next';
import { IconElements } from '../../../config/icons';

export const RemoveAccountModal: React.FC<{ formId: number, isShown: boolean, onClose: () => void, onRemoveAccount: (index: number) => void} & HTMLProps<HTMLDivElement>>
= ({ className, formId, isShown, onClose, onRemoveAccount}) => {
    const { t } = useTranslation('pension');

    return (
        <ModalScreenPension
            className={className}
            isShown={isShown}
        >
            <div className="flex-col justify-between bg-white md:mx-auto md:rounded-xl p-8">
                <RemoveAccountModalOverlay
                    title={t("pension-cocktail-fill-screen-supplement-remove-modal-title")}
                    className="mb-8"
                    onClose={onClose}
                />
                <div className="flex gap-4 flex-row flex-wrap justify-between">
                    <Button
                        className="font-bold"
                        tint="neutral-no-hover"
                        size="sm"
                        onClick={onClose}
                    >
                        {t("pension-cocktail-fill-screen-supplement-remove-modal-deny")}
                    </Button>
                    <Button 
                        className="font-bold" 
                        tint="green" 
                        size="sm"
                        onClick={() => {
                            onRemoveAccount(formId);
                            onClose();
                        }}
                    >
                        {t("pension-cocktail-fill-screen-supplement-remove-modal-confirm")}
                    </Button>
                    <div style={{ flex: 6 }}></div>
                </div>
            </div>
        </ModalScreenPension>
    )
}

const RemoveAccountModalOverlay: React.FC<
    { title?: string, onClose?: () => void } & HTMLProps<HTMLDivElement>
> = ({ title, onClose, className, ...rest }) => {
    return (
        <div {...rest} className={`flex flex-row justify-between items-center mb-8 ${className}`}>
            <span className="text-2xl font-semibold">{title}</span>
            {onClose && (
                <button
                    className="text-2xl flex items-center mt-2 focus:outline-none"
                    onClick={onClose}
                >
                    <IconElements.Cross className="text-bnd-green w-6 h-6 sm:h-8 sm:w-8 hover:text-bnd-green-hover transition" />
                </button>
            )}
        </div>
    );
}
